import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react";
import { ChevronDown } from "lucide-react";

// Shared status/option dropdown used by the LoadFinder truck modals.
// `value` is the option OBJECT ({ id, text }); `onChange` receives the option OBJECT.
export const SelectField = ({ value, onChange, options }) => (
    <Listbox value={value?.id ?? null} onChange={(id) => onChange(options.find((o) => o.id === id) ?? null)}>
        {({ open }) => (
            <div className="relative">
                <ListboxButton className="w-full flex items-center justify-between bg-cm-p-surface-container rounded-[6px] px-3 h-[40px] text-cm-p-text-primary text-[15px] font-medium border border-cm-p-outline focus:outline-none">
                    <span>{value?.text}</span>
                    <ChevronDown className={`w-4 h-4 text-cm-p-text-secondary shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
                </ListboxButton>
                <ListboxOptions
                    portal={false}
                    className="absolute z-modal-dropdown w-full mt-1 bg-cm-p-surface rounded-lg border border-cm-p-outline shadow-lg py-1 z-[21]"
                >
                    {options.map((option) => (
                        <ListboxOption
                            key={option.id}
                            value={option.id}
                            className="px-4 py-2.5 cursor-pointer hover:bg-cm-p-surface-hover text-cm-p-text-primary text-[15px] font-medium data-[focus]:bg-cm-p-surface-hover"
                        >
                            {option.text}
                        </ListboxOption>
                    ))}
                </ListboxOptions>
            </div>
        )}
    </Listbox>
);
